/**
 * @generated SignedSource<<49db14aa6446d507664d4e3617e958fe>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DesignsFeaturedItems_iconicDesignsDirectoryPage$data = {
  readonly designPages: ReadonlyArray<{
    readonly creators: ReadonlyArray<{
      readonly displayName: string | null;
    } | null> | null;
    readonly designName: string | null;
    readonly designUri: string | null;
    readonly imageUrl: string | null;
  } | null> | null;
  readonly " $fragmentType": "DesignsFeaturedItems_iconicDesignsDirectoryPage";
};
export type DesignsFeaturedItems_iconicDesignsDirectoryPage$key = {
  readonly " $data"?: DesignsFeaturedItems_iconicDesignsDirectoryPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"DesignsFeaturedItems_iconicDesignsDirectoryPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DesignsFeaturedItems_iconicDesignsDirectoryPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IconicDesignPage",
      "kind": "LinkedField",
      "name": "designPages",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "designName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "designUri",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "IconicDesignCreator",
          "kind": "LinkedField",
          "name": "creators",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "IconicDesignsDirectoryPage",
  "abstractKey": null
};

(node as any).hash = "66d579326d876c9bbf9e6f3d40ab1bab";

export default node;
